import { renderDayContents } from './renderDayContents';

export default renderDayContents;
